module.exports = __webpack_public_path__ + "static/media/unigauge.094b9c58.png";